var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgContinuumLogoWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 542.3,
    height: 99.2,
    viewBox: "0 0 542.3 99.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\r\n      .st0 {\r\n        fill: #fff;\r\n      }\r\n\r\n      .st1 {\r\n        fill: #55fa99;\r\n      }\r\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M159.2,85.6h-17.3V28.8h16.8v6.5c3.1-5.4,10-8,15.9-8,14.3,0,20.7,10.2,20.7,22.6v35.6h-17.3v-32.6c0-5.6-3-9.8-9.2-9.8s-9.4,4.2-9.4,9.9v32.5h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M224,28.8h11.1v15.2h-11.1v21.2c0,4.7,2.5,5.9,6.3,5.9s3.5-.3,4.6-.6v14.4c-.7.3-3.5,1.6-9,1.6-11.7,0-18.9-7-18.9-18.3v-24.3h-10v-15.2h2.9c5.9,0,8.8-4,8.8-9.2v-7.3h15.5v16.5h0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M238,85.6V28.8h17.3v56.7h-17.3Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M276.9,85.6h-17.3V28.8h16.8v6.5c3.1-5.4,10-8,15.9-8,14.3,0,20.7,10.2,20.7,22.6v35.6h-17.3v-32.6c0-5.6-3-9.8-9.2-9.8s-9.4,4.2-9.4,9.9v32.5h0Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M353.7,79.8c-3,4.9-9.5,7-15.2,7-13.8,0-21.6-10-21.6-22.1V28.8h17.3v32.2c0,5.5,3,9.8,9.1,9.8s9.5-4,9.5-9.7V28.8h17.3v46.6c0,5.1.5,9.2.6,10.2h-16.7c-.2-1-.5-4.2-.5-5.7h0Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M411.3,79.9c-3,4.9-9.5,7-15.2,7-13.8,0-21.6-10-21.6-22.1V28.9h17.3v32.2c0,5.5,3,9.8,9.1,9.8s9.5-4,9.5-9.7V28.9h17.3v46.6c0,5.1.5,9.2.6,10.2h-16.7c-.2-1-.5-4.2-.5-5.7h0Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M432.2,85.6V28.9h16.5v6.5c2.9-5,10.2-8.2,16.3-8.2s13.9,3.3,16.8,8.9c4.5-6.4,9.9-8.9,17.6-8.9s21,6.3,21,21.7v36.7h-16.8v-32.9c0-5.4-2.9-9.6-9-9.6s-9.5,4.7-9.5,9.7v32.7h-17.1v-32.9c0-5.4-2.9-9.6-9.1-9.6s-9.4,4.7-9.4,9.8v32.6h-17.3,0Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M51.9,47.8c4.7,0,8.5,3.8,8.5,8.4s-3.8,8.4-8.5,8.4-8.3-3.8-8.3-8.4,3.8-8.4,8.3-8.4Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M65.1,62.5c-2.3,4.9-7.3,8.3-13.1,8.3-8,0-14.1-6.4-14.1-14.3,0-7.9,6.4-14.3,14.1-14.3,5.8,0,10.7,3.3,13,8.2l14-4.2c-2.5-10.2-11.6-19.7-27.3-19.7-16.7,0-29.9,12.6-29.9,30.1,0,17.6,13.6,30,30.5,30,15.2,0,24.5-9.8,27-19.8l-14.3-4.4Z"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M139.8,56.7c0-17.6-13.2-30.1-29.9-30.1-.1,0-.2,0-.3,0-.1,0-.2,0-.3,0-16.7,0-29.9,12.6-29.9,30.1,0,10.9,5.2,19.8,13.2,25,4.4,3,9.9,5,16.7,5,0,0,.2,0,.3,0,0,0,.2,0,.3,0,6.7,0,12.3-1.9,16.7-5,8-5.2,13.2-14.1,13.2-25ZM109.6,70.9c-4.9,0-9.1-2.4-11.7-6.1-1.6-2.3-2.5-5.2-2.5-8.2,0-5.5,3.1-10.2,7.6-12.6.2-.1.4-.2.6-.3,0,0,0,0,0,0,1.8-.8,3.8-1.3,5.9-1.3,2.1,0,4.1.5,5.9,1.3,0,0,0,0,0,0,.2.1.4.2.6.3,4.5,2.4,7.6,7.2,7.6,12.6,0,3-.9,5.9-2.5,8.2-2.6,3.6-6.8,6-11.7,6.1Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContinuumLogoWhite);
export default __webpack_public_path__ + "static/media/ContinuumLogoWhite.eacc7fb230b5a95f44712fbb240d7279.svg";
export { ForwardRef as ReactComponent };